import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

//img
import arrowCircleEmptyMedium from '../../assets/icons/arrow-circle-empty-light.svg';

const PaginationNext = ({clang, setNextPage}) => {
    return (
        <button className="pagination__next" onClick={() => setNextPage()} title={lang[clang].pagination.next_title}>
            {lang[clang].pagination.next}
            <img className="pagination__next__img" src={arrowCircleEmptyMedium} alt="" />
        </button>
    );
};

PaginationNext.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(PaginationNext);



// WEBPACK FOOTER //
// ./src/components/pagination/PaginationNext.js